import { render, staticRenderFns } from "./fileItem.vue?vue&type=template&id=337fc29d&scoped=true"
import script from "./fileItem.vue?vue&type=script&lang=js"
export * from "./fileItem.vue?vue&type=script&lang=js"
import style0 from "./fileItem.vue?vue&type=style&index=0&id=337fc29d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337fc29d",
  null
  
)

export default component.exports